import React from 'react';
import {EntityListWithPagination, EntityWithIdFields} from "../../../types";
import {Mensaje, MensajeFields} from "../../messages/types";

import CardActions from "../../sistema/components/CardActions";
import {MensajePais} from "../../../types/enum/enum";
import {HttpMessages} from "../../../http/workflow/httpMessages";
import {MensajesRequestDTO, MensajesRequestFields} from "../../messages/api/schemas";
import {PaginationRequestFields} from "src/lib/itaptec/http_client/src";
import {IconButton, Stack, Tooltip, Typography} from "@mui/material";
import {rutaPorCodSistema} from "../../sistema/RefactorLayout";
import LaunchIcon from "@mui/icons-material/Launch";
import {useNavigate} from "react-router-dom";
import Chip from "../../../@core/components/mui/chip";
import {CountryAvatar} from "../../../components/icons/CountryAvatar";
import Icon from "../../../@core/components/icon";
import { useItecDataGrid, ItecDataGrid, ItecGridColsDef as GridColsDef } from 'src/lib/itaptec/datagrid/src';



interface DashboardTablaMensajesProps {
  codPais: MensajePais,
  codSistema: number,
  data: EntityListWithPagination<Mensaje>
}

function DashboardTablaMensajes({data, codPais, codSistema}: DashboardTablaMensajesProps) {
  const navigate = useNavigate()


  const columnas: GridColsDef<Mensaje>[] = [
    {
      headerName: 'Id Mensaje',
      renderCell: (params) => {
        const mensaje: Mensaje = params.row
        const messageId = mensaje[EntityWithIdFields.Id]
        const codSistema = mensaje[MensajeFields.CodSistemaTipo]

        return (
          <Stack direction={'column'}>
            <div>
              <Tooltip title='Abrir operación'>
                <IconButton

                  onClick={() => navigate(`/operacion/${rutaPorCodSistema[codSistema]}/${messageId}`)}>
                  <LaunchIcon
                    sx={{fontSize: '0.9rem'}}
                  />
                </IconButton>
              </Tooltip>
              {params.value}
            </div>
            <Tooltip title={mensaje[MensajeFields.Referencia]}>
              <Typography sx={{fontSize: '0.75rem'}}>{mensaje[MensajeFields.Referencia]}</Typography>
            </Tooltip>
          </Stack>

        )
      },
      field: EntityWithIdFields.Id, flex: 4
    },
    {
      headerName: 'Mensaje',
      renderCell: (params) => {
        const mensaje: Mensaje = params.row

        return (
          <Stack direction={'column'}>
            <Chip avatar={<CountryAvatar countryCode={mensaje[MensajeFields.CodigoSistemaPrincipal]}/>}
                  label={params.row[MensajeFields.NombreSistema]}/>
          </Stack>

        )
      },
      field: MensajeFields.NombreSistema, flex: 4
    },
    {
      headerName: 'Estado', field: MensajeFields.Estado,
      renderCell: (params) => {
        const mensaje: Mensaje = params.row

        return (
          <Stack direction={'row'} alignItems={'center'} gap={1}>
            <Icon
              icon='mdi:circle'
              color={mensaje[MensajeFields.HexColor]}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.5rem',
                flexShrink: 0,
              }}
            />
            <Tooltip title={mensaje[MensajeFields.Estado]}>
              <Typography
                sx={{
                  fontSize: '0.75rem',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 2,
                  lineHeight: '1.5',
                  whiteSpace: 'normal',
                }}
              >
                {params.value}
              </Typography>
            </Tooltip>
          </Stack>


        )
      },

      flex: 6
    },
    {
      headerName: 'Fecha creación', field: MensajeFields.FechaCreacion,
      valueFormatter: (params) => {
        const date = new Date(params.value);

        return new Intl.DateTimeFormat(undefined, {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        }).format(date);
      },
      flex: 3
    },
    {
      headerName: 'Fecha Ingreso Etapa', field: MensajeFields.FechaIngresoEtapa,
      valueFormatter: (params) => {
        const date = new Date(params.value);

        return new Intl.DateTimeFormat(undefined, {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        }).format(date);
      },
      flex: 3
    },

  ]

  const {
    datagridProps,
    control: {
      query: {refetch}
    }
  } = useItecDataGrid({
    pagination: true,
    columns: columnas,
    getEntitiesPaginated: (pagination, filter) => {
      const {actualPage, pageSize} = pagination;
      pagination[PaginationRequestFields.PageSize] = 100

      const mensajeRequest: MensajesRequestDTO = {
        [MensajesRequestFields.CodsSistemaPrincipal]: [codPais],
        [MensajesRequestFields.CodTipoMensaje]: [],
        [MensajesRequestFields.CodSistema]: codSistema === -1 ? [] : [codSistema],
        [MensajesRequestFields.FechaDesde]: null,
        [MensajesRequestFields.FechaHasta]: null,
        [MensajesRequestFields.Estados]: [],
        [MensajesRequestFields.IsResponsible]: true,

      }

      return HttpMessages.getByUser(mensajeRequest, pagination)

    },


  })

  return (
    <CardActions title={'Mensajes'} colapsable>
      <ItecDataGrid {...datagridProps} rowHeight={75}/>
    </CardActions>
  );
}

export default DashboardTablaMensajes;